import React, { useEffect, useState, useRef } from "react";
import axiosInstance from "../../api";
import moment from "moment";
import ViewEditReport from "./ViewEditReport";
import Swal from "sweetalert2";
import Pagination from "../Homepage/Pagination";
import { useLocation } from "react-router-dom";

export default function Reports() {
  const params = new URLSearchParams(useLocation().search);
  const [reports, setReports] = useState([]);
  const [loading, setloading] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [reportId, setReportId] = useState(0);
  const [showReport, setShowReport] = useState(false);
  const [refresh, setrefresh] = useState(false);
  const [page, setpage] = useState(1);
  const [search, setSearch] = useState(params.get("search") ?? "");
  const [isEmpty, setIsEmpty] = useState(false);
  const [isEnter, setIsEnter] = useState(false);
  const [pagecount, setpagecount]= useState(0);
  const [total, setTotal]= useState(0);

  useEffect(() => {
    setloading(true);
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/Report/GetAllReports?search=${search}&page=${page}`
      )
      .then((res) => {
        setReports(res.data?.data);
        setTotal(res.data?.count);
        setpagecount(res.data?.pages);
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [refresh, isEnter, page]);

  return (
    <section className="technician-vouchers">
      <h1>Reports</h1>
      {showReport && (
        <ViewEditReport
          isEdit={isEdit}
          setShowReport={setShowReport}
          reportId={reportId}
          setrefresh={setrefresh}
          refresh={refresh}
        />
      )}
      <input
        type="search"
        placeholder="Enter Search Keyword"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setIsEnter(!isEnter);
            setpage(1);
          }
        }}
      />
      <p><strong>Total: </strong>{total}</p>
      <section className="table">
        <section>
          <div>
            <aside style={{ gridTemplateColumns: "repeat(6, 1fr)" }}>
              <blockquote style={{ width: "25rem" }}>Username</blockquote>
              <blockquote style={{ width: "25rem" }}>TidketId</blockquote>
              <blockquote style={{ width: "25rem" }}>Service Date</blockquote>
              <blockquote style={{ gridColumn: "span 3" }}>Actions</blockquote>
            </aside>
          </div>
          <div>
            {reports?.length > 0 ? (
              <>
                {reports?.map((x, i) => (
                  <aside
                    key={x.id}
                    style={{ gridTemplateColumns: "repeat(6, 1fr)" }}
                  >
                    <blockquote style={{ width: "25rem" }}>
                      {x.technicianUserId}
                    </blockquote>
                    <blockquote style={{ width: "25rem" }}>
                      {x?.ticket?.seriesId}
                    </blockquote>
                    <blockquote style={{ width: "25rem" }}>
                      {moment(new Date(x.serviceDate)).format("DD/MM/YYYY")}
                    </blockquote>
                    <blockquote
                      onClick={() => {
                        setisEdit(false);
                        setReportId(x.id);
                        setShowReport(true);
                      }}
                    >
                      <i className="fa-solid fa-eye"></i>
                    </blockquote>
                    <blockquote
                      onClick={() => {
                        setisEdit(true);
                        setReportId(x.id);
                        setShowReport(true);
                      }}
                    >
                      <i className="fa-solid fa-pen-to-square"></i>
                    </blockquote>
                    <blockquote
                      onClick={() => {
                        Swal.fire({
                          title: "Delete Report",
                          text: "Are you sure you want to delete Report?",
                          showCancelButton: true,
                          showConfirmButton: true,
                          icon: "error",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            axiosInstance
                              .delete(
                                `${process.env.REACT_APP_API_URL}/api/Report/DeleteReport/${x.id}`
                              )
                              .then((res) => {
                                setrefresh(!refresh);
                              })
                              .catch(console.log);
                          }
                        });
                      }}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </blockquote>
                  </aside>
                ))}
                {loading && (
                  <aside style={{ gridTemplateColumns: "repeat(6, 1fr)" }}>
                    <blockquote style={{ gridColumn: "span 6" }}>
                      <center>
                        <i className="fa-solid fa-spineer fa-2x fa-spin"></i>
                      </center>
                    </blockquote>
                  </aside>
                )}
              </>
            ) : (
              <aside>
                <blockquote>No Records Found</blockquote>
              </aside>
            )}
          </div>
        </section>
      </section>
      <Pagination
          count={pagecount}
          setpagenumber={setpage}
          pagenumber={page}
        />
    </section>
  );
}
